import React from 'react';
import {Row} from "reactstrap";
import QraphChart from "./component/QraphChart";

const SquareOfSolidarity = (props) => {
    const timestamp=new Date().toString()

    return (
        <div className="content">
            <Row className={"justify-content-center"}>
                <QraphChart timestamp={timestamp}/>
            </Row>
        </div>
    )
};

export default SquareOfSolidarity;